export default __webpack_public_path__ + "static/Web4JobsLogo-7ee2a5832e1f6413d6e804b3605dda54.png";